// extracted by mini-css-extract-plugin
export default {"root":"AGfQ6M_MFzjRn40xhDDy","oldUpperSpace":"a9HUEH_DTcxCqjJBWDcv","error":"gi7oz216_VQXL9tvrhub","success":"YmIf6N0WNXw76avZpf56","placeHolderShimmer":"K8fOFyySJKwRMwgUWpsW"};